// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmail_container__XRLYs","success_img":"VerifyEmail_success_img__pxSAz","green_btn":"VerifyEmail_green_btn__mwFja"};